import { NextPage } from 'next'
import Head from 'next/head'
import React from 'react'
import Modal from 'react-modal'

import BankAccounts from '../assets/calculators/bankaccounts.svg'
import Cars from '../assets/calculators/cars.svg'
import CarsAlt from '../assets/calculators/carsalt.svg'
import CreditCard from '../assets/calculators/creditcard.svg'
import DebtRepayment from '../assets/calculators/debtcalc.svg'
import Education from '../assets/calculators/education.svg'
import EducationAlt from '../assets/calculators/educationalt.svg'
import HomeBuilding from '../assets/calculators/homebuildcalc.svg'
import Homes from '../assets/calculators/homes.svg'
import HomesAlt from '../assets/calculators/homesalt.svg'
import LifeInsurance from '../assets/calculators/lifeinsurancecalc.svg'
import LoanRefinance from '../assets/calculators/loanrefinancecalc.svg'
import LoanRepayment from '../assets/calculators/loanrepaycalc.svg'
import RentVsBuy from '../assets/calculators/rentbuycalc.svg'
import Retirement from '../assets/calculators/retirementcalc.svg'
import SavingsGeneral from '../assets/calculators/savingscalc.svg'
import SocialSecurity from '../assets/calculators/socialsecuritycalc.svg'
import { Layout } from '../components/Layout'
import { customStyles } from '../components/Modal'

const Calculators = () => {
  const [refinanceModalOpen, setRefinanceModalOpen] = React.useState(false)
  const [loanModalOpen, setLoanModalOpen] = React.useState(false)
  const [savingsModalOpen, setSavingsModalOpen] = React.useState(false)

  const loanCalculator = 'https://finaid.org/calculators/loanpayments/'
  const refinancingCalculator =
    'https://www.calculator.net/refinance-calculator.html'
  const savingsCalculator =
    'https://www.investor.gov/financial-tools-calculators/calculators/savings-goal-calculator'

  return (
    <Layout>
      <Head>
        <title>Calculators</title>
        <meta
          name="description"
          content="View our free, recommended calculators that make managing your finances a breeze!"
        />
      </Head>
      <div className="content">
        <div className="outer-container">
          <div className="inner-container">
            <p className="header mb30">Calculators</p>
            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="https://www.nerdwallet.com/article/finance/debt-snowball-calculator"
                >
                  <img alt="icon" className="icon" src={DebtRepayment.src} />
                  <p className="icon-title">Debt Repayment</p>
                </a>
              </div>
              <div className="icon-container">
                <button
                  type="button"
                  onClick={() => setLoanModalOpen(true)}
                  className="icon-link"
                >
                  <img
                    alt="icon"
                    id="loanRepaymentModal"
                    className="icon"
                    src={LoanRepayment.src}
                  />
                  <p id="loanRepaymentModal" className="icon-title">
                    Loan Repayment
                  </p>
                </button>
              </div>
              <div className="icon-container">
                <button
                  type="button"
                  onClick={() => setRefinanceModalOpen(true)}
                  className="icon-link"
                >
                  <img
                    alt="icon"
                    id="loanRefinancingModal"
                    className="icon"
                    src={LoanRefinance.src}
                  />
                  <p id="loanRefinancingModal" className="icon-title">
                    Loan Refinancing
                  </p>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="icon-container">
                <button
                  type="button"
                  onClick={() => setSavingsModalOpen(true)}
                  className="icon-link"
                >
                  <img
                    alt="icon"
                    id="savingsModal"
                    className="icon"
                    src={SavingsGeneral.src}
                  />
                  <p id="savingsModal" className="icon-title">
                    Savings
                  </p>
                </button>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  href="https://networthify.com/calculator/earlyretirement"
                >
                  <img alt="icon" className="icon" src={Retirement.src} />
                  <p className="icon-title">Retirement</p>
                </a>
              </div>
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="http://www.aarp.org/work/social-security/social-security-benefits-calculator.html"
                >
                  <img alt="icon" className="icon" src={SocialSecurity.src} />
                  <p className="icon-title">Social Security</p>
                </a>
              </div>
            </div>
            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="http://www.nytimes.com/interactive/2014/upshot/buy-rent-calculator.html?_r=0"
                >
                  <img alt="icon" className="icon" src={RentVsBuy.src} />
                  <p className="icon-title">Rent vs. Buy</p>
                </a>
              </div>
              <div className="icon-container">
                <a
                  className="zicon-link"
                  href="http://www.building-cost.net/Valuation/Start"
                >
                  <img alt="icon" className="icon" src={HomeBuilding.src} />
                  <p className="icon-title">Home Rebuilding</p>
                </a>
              </div>
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="http://www.lifehappens.org/insurance-overview/life-insurance/calculate-your-needs/"
                >
                  <img alt="icon" className="icon" src={LifeInsurance.src} />
                  <p className="icon-title">Life Insurance</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Modals */}

        {/* Refinancing */}
        <Modal
          ariaHideApp={false}
          isOpen={refinanceModalOpen}
          onRequestClose={() => setRefinanceModalOpen(false)}
          className="content"
          // @ts-ignore
          style={customStyles}
        >
          <div className="modal">
            <div className="modal-icon-container">
              <div className="icon-container">
                <a className="icon-link" href={refinancingCalculator}>
                  <img alt="icon" className="icon" src={CreditCard.src} />
                  <p className="icon-title">General</p>
                </a>
              </div>
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="https://www.nerdwallet.com/mortgages/refinance-calculator"
                >
                  <img alt="icon" className="icon" src={Homes.src} />
                  <p className="icon-title">Mortgage</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={refinancingCalculator}>
                  <img alt="icon" className="icon" src={Cars.src} />
                  <p className="icon-title">Cars</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={refinancingCalculator}>
                  <img alt="icon" className="icon" src={Education.src} />
                  <p className="icon-title">Student</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>

        {/* Loan */}
        <Modal
          ariaHideApp={false}
          isOpen={loanModalOpen}
          onRequestClose={() => setLoanModalOpen(false)}
          className="content"
          // @ts-ignore
          style={customStyles}
        >
          <div className="modal">
            <div className="modal-icon-container">
              <div className="icon-container">
                <a className="icon-link" href={loanCalculator}>
                  <img alt="icon" className="icon" src={CreditCard.src} />
                  <p className="icon-title">General</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={loanCalculator}>
                  <img alt="icon" className="icon" src={Homes.src} />
                  <p className="icon-title">Mortgage</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={loanCalculator}>
                  <img alt="icon" className="icon" src={Cars.src} />
                  <p className="icon-title">Cars</p>
                </a>
              </div>
              <div className="icon-container">
                <a
                  className="icon-link"
                  href="https://studentloans.gov/myDirectLoan/mobile/repayment/repaymentEstimator.action"
                >
                  <img alt="icon" className="icon" src={Education.src} />
                  <p className="icon-title">Student</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>

        {/* Savings */}
        <Modal
          ariaHideApp={false}
          isOpen={savingsModalOpen}
          onRequestClose={() => setSavingsModalOpen(false)}
          className="content"
          // @ts-ignore
          style={customStyles}
        >
          <div className="modal">
            <div className="modal-icon-container">
              <div className="icon-container">
                <a className="icon-link" href={savingsCalculator}>
                  <img alt="icon" className="icon" src={BankAccounts.src} />
                  <p className="icon-title">General</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={savingsCalculator}>
                  <img alt="icon" className="icon" src={HomesAlt.src} />
                  <p className="icon-title">Home</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={savingsCalculator}>
                  <img alt="icon" className="icon" src={CarsAlt.src} />
                  <p className="icon-title">Cars</p>
                </a>
              </div>
              <div className="icon-container">
                <a className="icon-link" href={savingsCalculator}>
                  <img alt="icon" className="icon" src={EducationAlt.src} />
                  <p className="icon-title">College</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Layout>
  )
}

export default Calculators
